/**
 * Created by jv on 2019-09-10 (14:34).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
// import CONSTANTS from "Sources/config/constants";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/business-model.html";
import LanguageManager from "Sources/services/language-manager";

import GameProgressController from "Sources/controllers/game-progress-controller";

import BusinessModel from "Sources/components/business-model/business-model";
import testLayout from "Sources/components/business-model/layouts/default"; // %NOTE: CMS.faq also uses this config, please change there too :)
import InvestmentSlider from "Sources/components/game/components/investment-slider";
import InvestmentDialog from "Sources/components/game/components/investment-dialog";
import InvestmentExtraDialog from "Sources/components/game/components/investment-extra-dialog";
import CloseRoundDialog from "Sources/components/game/components/close-round-dialog";
import TutorialDialog from "Sources/components/game/components/tutorial-dialog";
import EventDialog from "Sources/components/game/components/event-dialog";
import ExampleCaseDialog from "Sources/components/game/components/example-case-dialog";
import FaqDialog from "Sources/components/game/components/faq-dialog";
import GameBonusDialog from "Sources/components/game/components/game-bonus-dialog";
import LoanDialog from "Sources/components/game/components/loan-dialog";
import ScoreScreen from "Sources/components/game/components/score-screen";
import DataHistory from "Sources/components/game/components/data-history";

require("Styles/components/views/business-model.scss");

class BusinessModelView extends GameView {
  constructor(options) {
    options.html = $(htmlView);
    super(options);

    this.path = "business-model";

    this.businessModel = null;

    this.gameSession = options.gameSession;
    this.team = options.team;
    this.caseWrapper = options.caseWrapper;
    this.roundOverview = options.roundOverview;

    this.scoreScreenMode = null;

    this.onRenderCompleted = options.onRenderComplete;

    this.onInvestmentAdded = options.onInvestmentAdded;
    this.onTeamClosedRound = options.onTeamClosedRound;
    this.onTeamRequestedLoan = options.onTeamRequestedLoan;
    this.onTeamOverviewChanged = options.onTeamOverviewChanged;

    this.executeOnRender = [];
    this.executeOnEventClose = [];
    this.executeOnInvestmentClose = [];
    this.executeOnInvestmentExtraClose = [];
    this.executeOnExampleCasesClose = [];
    this.executeOnTutorialClose = [];
    this.executeOnLoanDialogClose = [];

    this.showBusinessModelOnRender = true;
  }

  render() {
    super.render();

    this.rendered = false;

    this.$element.find(".bm-action__data.bm-data__budget").prop("disabled", true);
    this.$element.find(".bm-action__data.bm-data__points").prop("disabled", true);

    this.$loader = this.$element.find(".business-model__loader");
    this.$businessModelCanvas = this.$element.find(".bm__canvas");
    this.$scoreScreenContainer = this.$element.find(".bm__score-screen");
    this.$investmentsSlider = this.$element.find(".bm__investment-slider");
    this.$actionBarWrapper = this.$element.find(".action-bar__wrapper");
    this.$actionBarMain = this.$element.find(".action-bar.action-bar__main");
    this.$actionBarPreview = this.$element.find(".action-bar.action-bar__preview");
    this.$actionBarFaq = this.$element.find(".action-bar.action-bar__faq");

    this.setActionBarVisible(false);

    this.renderBusinessModelCanvas();
    this.renderScoreScreen();
    this.renderInvestmentsCarousel();
    this.renderInvestmentDialog();
    this.renderCloseRoundDialog();
    this.renderTutorialDialog();
    this.renderEventDialog();
    this.renderExampleCasesDialog();
    this.renderInvestmentExtraDialog();
    this.renderFaqDialog();
    this.renderGameBonusDialog();
    this.renderLoanDialog();

    this.renderBudgetHistory();
    this.renderPointsHistory();

    this.showBusinessModel(false);
    this.showLoader(true);

    this._setUpEventListeners();
  }

  onRender() {
    super.onRender();

    log.info("Business model has rendered");

    this.rendered = true;

    this.refreshRoundData();

    if (this.showBusinessModelOnRender) {
      this.showBusinessModel(true, false);
    }

    // if(this.roundOverview.currentRoundData.roundIndex === 1 && utils.isNull(this.roundOverview.currentRoundData.closed))
    // {
    //   this.showTutorialDialog();
    // }

    this.setActionBarVisible(true);
    this.$element.find(".bm-action__data.bm-data__budget").prop("disabled", false);
    this.$element.find(".bm-action__data.bm-data__points").prop("disabled", false);

    for (let i = 0; i < this.executeOnRender.length; i++) {
      if (utils.isFunction(this.executeOnRender[i])) {
        this.executeOnRender[i].call(this);
      }
    }

    if (utils.isFunction(this.onRenderCompleted)) {
      this.onRenderCompleted.call(this);
    }
  }

  renderBusinessModelCanvas() {
    this.businessModel = new BusinessModel({
      containerElement: this.$businessModelCanvas,
      layoutData: testLayout,
      onRenderComplete: () => {
        this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;
        this.businessModel.setUpBeginState();
        this.onRender();
      },
      onFaqClick: (faqInfo) => {
        log.info("Clicked on faq item - %o", faqInfo);
        this.showFaqDialog(faqInfo.faqType);
      }
    });

    log.info("Rendering business model: %o", this.businessModel);

    this.businessModel.render();
  }

  renderScoreScreen() {
    if (utils.isNotNull(this.scoreScreen)) {
      this.scoreScreen.destroy();
    }

    this.scoreScreen = new ScoreScreen({
      container: this.$scoreScreenContainer,
      team: this.team,
      teams: this.gameSession.teamList,
      callbackContext: this,
      onTeamScoreClick: this.onTeamScoreClick
    });

    this.scoreScreen.render();
  }

  renderInvestmentsCarousel() {
    if (utils.isNotNull(this.investmentSlider)) {
      this.investmentSlider.destroy();
    }

    this.investmentSlider = new InvestmentSlider({
      container: this.$investmentsSlider,
      team: this.team,
      roundOverview: this.roundOverview,
      investments: this.caseWrapper.investments,
      onInvestmentClicked: (investment) => this.onInvestmentClicked(investment)
    });

    this.investmentSlider.render();
  }

  renderInvestmentDialog() {
    if (utils.isNotNull(this.investmentDialog)) {
      this.investmentDialog.destroy();
    }

    this.investmentDialog = new InvestmentDialog({
      team: this.team,
      roundOverview: this.roundOverview,
      investments: this.caseWrapper.investments,
      callbackContext: this,
      onCancel: this.onInvestmentDialogCancel,
      onViewExampleCases: this.onInvestmentViewExamples,
      onPreview: this.onInvestmentShowPreview,
      onPurchase: this.onInvestmentPurchased
    });

    this.investmentDialog.create();
  }

  renderCloseRoundDialog() {
    if (utils.isNotNull(this.closeRoundDialog)) {
      this.closeRoundDialog.destroy();
    }

    this.closeRoundDialog = new CloseRoundDialog({
      roundOverview: this.roundOverview,
      callbackContext: this,
      onCancel: this.onCloseRoundDialogCancel,
      onViewInvestments: this.onViewInvestments,
      onCloseRound: this.closeRound
    });

    this.closeRoundDialog.create();
  }

  renderTutorialDialog() {
    if (utils.isNotNull(this.tutorialDialog)) {
      this.tutorialDialog.destroy();
    }

    this.tutorialDialog = new TutorialDialog({
      callbackContext: this,
      onCancel: this.onTutorialCancel
    });

    this.tutorialDialog.create();
  }

  renderEventDialog() {
    if (utils.isNotNull(this.eventDialog)) {
      this.eventDialog.destroy();
    }

    this.eventDialog = new EventDialog({
      callbackContext: this,
      onCancel: this.onEventDialogCancel,
    });

    this.eventDialog.create();
  }

  renderExampleCasesDialog() {
    if (utils.isNotNull(this.exampleCasesDialog)) {
      this.exampleCasesDialog.destroy();
    }

    this.exampleCasesDialog = new ExampleCaseDialog({
      callbackContext: this,
      onCancel: this.onExampleCaseDialogCancel,
    });

    this.exampleCasesDialog.create();
  }

  renderInvestmentExtraDialog() {
    if (utils.isNotNull(this.investmentExtraDialog)) {
      this.investmentExtraDialog.destroy();
    }

    this.investmentExtraDialog = new InvestmentExtraDialog({
      callbackContext: this,
      onCancel: this.onInvestmentExtraDialogCancel,
    });

    this.investmentExtraDialog.create();
  }

  renderFaqDialog() {
    if (utils.isNotNull(this.faqDialog)) {
      this.faqDialog.destroy();
    }

    this.faqDialog = new FaqDialog({
      callbackContext: this,
      onCancel: this.onFaqDialogCancel,
      onViewInvestment: this.onViewInvestment
    });

    this.faqDialog.create();
  }

  renderGameBonusDialog() {
    if (utils.isNotNull(this.gameBonusDialog)) {
      this.gameBonusDialog.destroy();
    }

    this.gameBonusDialog = new GameBonusDialog({
      callbackContext: this,
      onCancel: this.onGameBonusDialogCancel,
    });

    this.gameBonusDialog.create();
  }

  renderLoanDialog() {
    if (utils.isNotNull(this.loanDialog)) {
      this.loanDialog.destroy();
    }

    this.loanDialog = new LoanDialog({
      callbackContext: this,
      onCancel: this.onLoanDialogCancel,
      onRequestLoan: this.requestLoan
    });

    this.loanDialog.create();
  }

  renderBudgetHistory() {
    this.budgetHistoryComponent = new DataHistory({
      triggerElement: this.$element.find(".bm-action__data.bm-data__budget")
    });

    this.budgetHistoryComponent.create();
  }

  renderPointsHistory() {
    this.pointsHistoryComponent = new DataHistory({
      triggerElement: this.$element.find(".bm-action__data.bm-data__points")
    });

    this.pointsHistoryComponent.create();
  }

  renderGameProgressController() {
    if (utils.isNotNull(this.gameProgressController)) {
      this.gameProgressController.destroy();
    }

    this.gameProgressController = new GameProgressController({
      container: this.$element.find(".business-model__progress-view"),
      onRenderComplete: () => {
        this.gameProgressController.update();
      }
    });

    log.info("Rendering game progress controller: %o", this.gameProgressController);

    this.gameProgressController.render();
  }

  hide() {
    super.hide();

    if (utils.isNotNull(this.investmentDialog)) {
      this.removeBackdrop();

      // Also hide dialogs when hiding the game view!
      this.hideAllDialogs();
    }
  }

  hideAllDialogs() {
    this.hideInvestmentDialog(false);
    this.hideInvestmentExamplesDialog(false);
    this.hideInvestmentExtraDialog(false);
    this.hideCloseRoundDialog(false);
    this.hideEventDialog(false);
    this.hideTutorialDialog(false);
    this.hideFaqDialog(false);
    this.hideGameBonusDialog(false);
    this.hideLoanDialog(false);
  }

  showBusinessModel(flag, hideOthers, removePreview) {
    if (flag) {
      if (hideOthers !== false) {
        this.hideAllDialogs();
        this.hideInvestments();
        this.hideScoreScreen();
      }

      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
      this.$element.find(".bm-action-btn__model").addClass("bm-action__active");

      this.removeBackdrop();

      if (this.businessModel.hasRendered()) {
        if (removePreview !== false) {
          this.hidePreview();
        }
        this.hideFaq();

        this.showLoader(false);
        this.$businessModelCanvas.show();

        // if(utils.isNotNull(this.hideCanvasAnimationTimeout))
        // {
        //   clearTimeout(this.hideCanvasAnimationTimeout);
        //   this.hideCanvasAnimationTimeout = null;
        // }
        //
        // this.$businessModelCanvas.show();
        // this.$businessModelCanvas.addClass("bm__visible");
      } else {
        this.showBusinessModelOnRender = true;
        this.showLoader(true);
      }
    } else {
      // if(utils.isNotNull(this.hideCanvasAnimationTimeout))
      // {
      //   clearTimeout(this.hideCanvasAnimationTimeout);
      //   this.hideCanvasAnimationTimeout = null;
      // }
      //
      // this.$businessModelCanvas.removeClass("bm__visible");
      // this.hideCanvasAnimationTimeout = setTimeout(() =>
      // {
      //   this.hideCanvasAnimationTimeout = null;
      //   this.$businessModelCanvas.hide();
      // }, CONSTANTS.BM_TRANSITION_SPEED);

      this.$businessModelCanvas.hide();
    }
  }

  showLoader(flag) {
    if (flag) this.$loader.show();
    else this.$loader.hide();
  }

  showScoreScreen(options) {
    if (!this.rendered) {
      this.executeOnRender.push(() => this.showScoreScreen(options));
      return;
    }

    let title = options.title,
      roundIndex = options.roundIndex,
      asOverlay = options.asOverlay === true;

    this.scoreScreenMode = options.mode || "current-round";

    this.scoreScreen.isFinal = this.scoreScreenMode === "endgame";
    this.scoreScreen.title = title;
    this.scoreScreen.roundIndex = roundIndex;
    this.scoreScreen.team = this.team;
    this.scoreScreen.roundOverview = this.roundOverview;
    this.scoreScreen.interactive = options.interactive === true;

    this.showLoader(false);
    this.hideInvestments();
    this.hideAllDialogs();

    if (asOverlay) {
      this.showBusinessModel(true, false);
      this.$scoreScreenContainer.removeClass("bm__background-filled");
      this.showBackdrop();
    } else {
      if (options.keepVisible === true) this.showBusinessModelOnRender = false;

      if (options.hideBusinessModel !== false) {
        this.showBusinessModel(false);
      }

      this.$scoreScreenContainer.addClass("bm__background-filled");
      this.removeBackdrop();
      this.setActionBarVisible(false);
    }

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    this.$element.find(".bm-action-btn__score").addClass("bm-action__active");

    this.scoreScreen.show(asOverlay);
    this.$scoreScreenContainer.show().addClass("bm__visible");
  }

  updateScoreScreen() {
    this.scoreScreen.team = this.team;
    this.scoreScreen.roundOverview = this.roundOverview;
    this.scoreScreen.update();
  }

  updateTeamList(teamList) {
    this.gameSession.teamList = teamList;

    if (utils.isNotNull(this.scoreScreen)) {
      this.scoreScreen.updateTeamList(teamList);
    }
  }

  hideScoreScreen(removeBackdrop) {
    if (removeBackdrop !== false) {
      this.removeBackdrop();
    }

    this.scoreScreen.hide();
    this.$scoreScreenContainer.removeClass("bm__visible");
    this.setActionBarVisible(true);
  }

  showInvestments() {
    log.debug("Showing investments slider");

    this.showBusinessModel(true, true);

    this.showBackdrop();

    this.investmentSlider.show();

    $("body").addClass("game__investments-open");
    this.$investmentsSlider.show().addClass("bm__visible");

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);
  }

  hideInvestments(hideOverlay) {
    if (hideOverlay) this.removeBackdrop();

    $("body").removeClass("game__investments-open");
    this.$investmentsSlider.removeClass("bm__visible");

    this.investmentSlider.hide();

    this.$element.find(".bm-action-btn__investments").removeClass("bm-action__active").prop("disabled", false);
  }

  showInvestmentDialog(investment) {
    if (this.investmentDialog.isOpen) {
      return;
    }

    if (utils.isNotNull(investment)) this.investmentDialog.investment = investment;
    if (utils.isNull(this.investmentDialog.investment)) return;

    this.hideInvestmentExtraDialog(false);
    this.hideInvestments();

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);

    this.showBackdrop();
    this.investmentDialog.team = this.team;
    this.investmentDialog.roundOverview = this.roundOverview;
    this.investmentDialog.show();
  }

  hideInvestmentDialog(removeBackdrop) {
    if (utils.isNotNull(this.investmentDialog)) {
      if (removeBackdrop !== false) {
        this.removeBackdrop();
      }

      this.investmentDialog.hide();
    }
  }

  showInvestmentExamplesDialog(investment) {
    if (this.exampleCasesDialog.isOpen) {
      return;
    }

    if (utils.isNull(investment)) return;

    this.hideInvestmentExtraDialog(false);
    this.hideInvestments();

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);

    this.showBackdrop();
    this.exampleCasesDialog.investment = investment;

    this.executeOnExampleCasesClose.push(() => {
      this.showInvestmentDialog(investment);
    });

    this.hideInvestmentDialog(false);
    this.exampleCasesDialog.show();

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);
  }

  hideInvestmentExamplesDialog(removeBackdrop) {
    if (utils.isNotNull(this.exampleCasesDialog)) {
      if (removeBackdrop !== false) {
        this.removeBackdrop();
      }

      this.exampleCasesDialog.hide();
    }
  }

  showPreview(investment) {
    if (!this.rendered) {
      this.executeOnRender.push(() => this.showPreview(investment));
      return;
    }

    if (utils.isNotNull(investment)) {
      this.showBusinessModel(true, true);

      this.setUpPreviewResult(investment);

      this.$element.find(".bm-action-btn").removeClass("bm-action__active");

      this.showActionBar("preview");
      this.businessModel.previewInvestment(investment.type);
    }
  }

  hidePreview() {
    this.showActionBar("main");

    this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;
    this.businessModel.removePreview();
  }

  showFaq() {
    if (!this.rendered) {
      this.executeOnRender.push(() => this.showFaq());
      return;
    }

    this.showBusinessModel(true, true);

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    this.$element.find(".bm-action-btn__faq").addClass("bm-action__active");

    this.showActionBar("faq");

    if (!this.businessModel.faqIconsVisible) {
      this.businessModel.toggleFaqIcons();
    }
  }

  hideFaq() {
    if (this.businessModel.faqIconsVisible) {
      this.businessModel.toggleFaqIcons();
    }

    this.showActionBar("main");
  }

  showEventDialog(moveActionBarBackwards, executeOnClose) {
    if (this.eventDialog.isOpen) {
      return;
    }

    if (moveActionBarBackwards) {
      this.setActionBarLayer(true);

      this.executeOnEventClose.push(() => {
        this.setActionBarLayer(false);
      });
    }

    if (utils.isFunction(executeOnClose)) {
      this.executeOnEventClose.push(executeOnClose);
    }

    this.showBusinessModel(true, true);
    this.showBackdrop();

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    this.$element.find(".bm-action-btn__event").addClass("bm-action__active");

    this.eventDialog.event = this.roundOverview.currentEvent;
    this.eventDialog.show();
  }

  hideEventDialog(removeBackdrop) {
    if (removeBackdrop !== false) {
      this.removeBackdrop();
    }

    this.eventDialog.hide();
  }

  showCloseRoundDialog() {
    if (this.closeRoundDialog.isOpen) {
      return;
    }

    this.showBusinessModel(true, true);
    this.showBackdrop();

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    this.$element.find(".bm-action-btn__close-round").addClass("bm-action__active");

    this.closeRoundDialog.roundOverview = this.roundOverview;
    this.closeRoundDialog.show();
  }

  hideCloseRoundDialog(removeBackdrop) {
    if (removeBackdrop !== false) {
      this.removeBackdrop();
    }

    this.closeRoundDialog.hide();
  }

  showTutorialDialog(moveActionBarBackwards) {
    if (this.tutorialDialog.isOpen) {
      return;
    }

    if (moveActionBarBackwards) {
      this.setActionBarLayer(true);

      this.executeOnTutorialClose.push(() => {
        this.setActionBarLayer(false);
      });
    }

    this.showBusinessModel(true, true);
    this.showBackdrop();

    this.$element.find(".bm-action-btn").removeClass("bm-action__active");

    this.tutorialDialog.show();
  }

  hideTutorialDialog(removeBackdrop) {
    if (removeBackdrop !== false) {
      this.removeBackdrop();
    }

    this.tutorialDialog.hide();
  }

  showInvestmentExtra(investmentType, data, moveActionBarBackwards, executeOnClose) {
    if (this.investmentExtraDialog.isOpen) {
      return;
    }

    if (!this.rendered) {
      this.executeOnRender.push(() => this.showInvestmentExtra(investmentType, data, moveActionBarBackwards, executeOnClose));
      return;
    }

    let investment = null;

    for (let i = 0; i < this.caseWrapper.investments.length; i++) {
      if (this.caseWrapper.investments[i].type === investmentType) {
        investment = this.caseWrapper.investments[i];
      }
    }

    if (utils.isNotNull(investment)) {
      if (moveActionBarBackwards) {
        this.setActionBarLayer(true);

        this.executeOnInvestmentExtraClose.push(() => {
          this.setActionBarLayer(false);
        });
      }

      if (utils.isFunction(executeOnClose)) {
        this.executeOnInvestmentExtraClose.push(executeOnClose);
      }

      this.showBusinessModel(true, true);
      this.showBackdrop();

      this.$element.find(".bm-action-btn").removeClass("bm-action__active");

      this.investmentExtraDialog.investment = investment;
      this.investmentExtraDialog.extraData = data;
      this.investmentExtraDialog.show();
    }
  }

  hideInvestmentExtraDialog(removeBackdrop) {
    if (removeBackdrop !== false) {
      this.removeBackdrop();
    }

    this.investmentExtraDialog.hide();
  }

  showFaqDialog(faqType) {
    if (this.faqDialog.isOpen) {
      return;
    }

    if (!this.rendered) {
      this.executeOnRender.push(() => this.showFaqDialog(faqType));
      return;
    }

    if (utils.isNotNull(this.faqDialog)) {
      if (utils.isNull(faqType)) faqType = this.faqDialog.faqType;
      if (utils.isNull(faqType)) return;

      this.showFaq();
      this.showBackdrop();

      this.$element.find(".bm-action-btn").removeClass("bm-action__active");

      this.faqDialog.faqItems = this.caseWrapper.faqList;
      this.faqDialog.investments = this.caseWrapper.investments;
      this.faqDialog.faqType = faqType;
      this.faqDialog.show();
    }
  }

  hideFaqDialog(removeBackdrop) {
    if (removeBackdrop !== false) {
      this.removeBackdrop();
    }

    this.faqDialog.hide();
  }

  showGameBonusDialog(bonusType, bonusValue) {
    if (this.gameBonusDialog.isOpen) {
      return;
    }

    if (!this.rendered) {
      this.executeOnRender.push(() => this.showGameBonusDialog(bonusType, bonusValue));
      return;
    }

    if (utils.isNotNull(this.gameBonusDialog)) {
      this.showBusinessModel(true, true);
      this.showBackdrop();

      this.$element.find(".bm-action-btn").removeClass("bm-action__active");

      this.gameBonusDialog.circular = bonusType === "circular-bonus";
      this.gameBonusDialog.bonus = bonusValue;
      this.gameBonusDialog.show();
    }
  }

  hideGameBonusDialog(removeBackdrop) {
    if (removeBackdrop !== false) {
      this.removeBackdrop();
    }

    this.gameBonusDialog.hide();
  }

  showLoanDialog(type, moveActionBarBackwards, executeOnClose) {
    if (this.loanDialog.isOpen) {
      return;
    }

    if (!this.rendered) {
      this.executeOnRender.push(() => this.showLoanDialog(type, moveActionBarBackwards, executeOnClose));
      return;
    }

    if (utils.isNotNull(this.loanDialog)) {
      if (moveActionBarBackwards) {
        this.setActionBarLayer(true);

        this.executeOnLoanDialogClose.push(() => {
          this.setActionBarLayer(false);
        });
      }

      if (utils.isFunction(executeOnClose)) {
        this.executeOnLoanDialogClose.push(executeOnClose);
      }

      this.showBusinessModel(true, true);
      this.showBackdrop();

      this.$element.find(".bm-action-btn").removeClass("bm-action__active");

      this.loanDialog.roundOverview = this.roundOverview;
      this.loanDialog.type = type;
      this.loanDialog.show();
    }
  }

  hideLoanDialog(removeBackdrop) {
    if (removeBackdrop !== false) {
      this.removeBackdrop();
    }

    this.loanDialog.hide();
  }

  showBudgetHistory() {
    if (!this.rendered) {
      this.executeOnRender.push(() => this.showBudgetHistory());
      return;
    }

    this.budgetHistoryComponent.show();
  }

  refreshRoundData() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.setActionButtonState();

      // Update business model
      if (utils.isNotNull(this.businessModel)) {
        this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;

        let teamInvestments = this.getInvestmentObjectsForTeam();
        teamInvestments = teamInvestments.map(ti => ti.type);
        this.businessModel.updateInvestments(teamInvestments);

        let productIcon = null;
        let extraProductIcon = null;

        for (let i = 0; i < this.caseWrapper.icons.length; i++) {
          let icon = this.caseWrapper.icons[i];

          if (icon.type === "product") {
            productIcon = icon;
          } else if (utils.isNotNull(this.roundOverview.currentRoundData.extraProductId) && this.roundOverview.currentRoundData.extraProductId === icon.type) {
            extraProductIcon = icon;
          }
        }

        if (utils.isNotNull(productIcon)) {
          this.businessModel.setCompanyIcon(productIcon.value);
        }

        if (utils.isNotNull(extraProductIcon)) {
          this.businessModel.setCompanyExtraProduct(extraProductIcon.value);
        }
      }

      // Update investments slider
      this.investmentSlider.team = this.team;
      this.investmentSlider.investments = this.caseWrapper.investments;
      this.investmentSlider.roundOverview = this.roundOverview;

      // Update investment dialog
      this.investmentDialog.team = this.team;
      this.investmentDialog.investments = this.caseWrapper.investments;
      this.investmentDialog.roundOverview = this.roundOverview;
      this.investmentDialog.renderDialogContent();

      // Update event dialog
      if (utils.isNotNull(this.roundOverview.currentEvent)) {
        this.eventDialog.event = this.roundOverview.currentEvent;
      }

      // Update score screen
      this.scoreScreen.roundOverview = this.roundOverview;

      if (this.scoreScreenMode === "previous-round") this.scoreScreen.roundIndex = this.roundOverview.currentRoundData.roundIndex - 1;
      else this.scoreScreen.roundIndex = null;

      this.updateScoreScreen();
    }
  }

  setRoundOverview(roundOverview) {
    this.roundOverview = roundOverview;
    this.refreshRoundData();
  }

  showActionBar(name) {
    this.hideActionBars();

    switch (name) {
      case "faq":
        this.$actionBarFaq.show();
        break;
      case "preview":
        this.$actionBarPreview.show();
        break;
      case "main":
      default:
        this.$actionBarMain.show();
    }
  }

  hideActionBars() {
    this.$actionBarMain.hide();
    this.$actionBarPreview.hide();
    this.$actionBarFaq.hide();
  }

  setActionButtonState() {
    this.$element.find("[data-bm-current-budget]").text(this.roundOverview.currentRoundData.currentBudget);
    this.$element.find("[data-bm-current-points]").text(this.roundOverview.currentRoundData.currentPoints);

    this.budgetHistoryComponent.setComponentHtml(this.roundOverview, "budget");
    this.pointsHistoryComponent.setComponentHtml(this.roundOverview, "points");

    let investmentCount = 2;
    if (utils.isNotNull(this.roundOverview.currentRoundData.investmentKey1)) investmentCount--;
    if (utils.isNotNull(this.roundOverview.currentRoundData.investmentKey2)) investmentCount--;
    this.$element.find(".bm-investment-count").text(investmentCount);

    let previousRoundScore = this.getRoundScore(this.roundOverview.currentRoundData.roundIndex - 1);
    let hasPreviousRoundScore = utils.isNotNull(previousRoundScore) && previousRoundScore.round !== 0;

    if (hasPreviousRoundScore) {
      this.$element.find(".bm-action-btn__score").show();
    } else {
      this.$element.find(".bm-action-btn__score").hide();
    }

    if (utils.isNotNull(this.roundOverview.currentEvent)) {
      this.$element.find(".bm-action-btn__event").prop("disabled", false).show();
    } else {
      this.$element.find(".bm-action-btn__event").prop("disabled", true).hide();
    }

    if (this.roundOverview.currentRoundData.canLoan) {
      this.$element.find(".bm-action-btn__loan").show();
    } else {
      this.$element.find(".bm-action-btn__loan").hide();
    }
  }

  setUpPreviewResult(previewInvestment) {
    let investmentCost = InvestmentSlider.getCostForInvestment(this.roundOverview, previewInvestment);
    let previewBudget = this.roundOverview.currentRoundData.currentBudget - investmentCost;

    if (previewInvestment.type === "subsidy") {
      this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;
      previewBudget += previewInvestment.income;
    } else {
      this.businessModel.income = this.roundOverview.currentRoundData.currentIncome + previewInvestment.income;

      if (previewInvestment.income > 0) {
        this.businessModel.setIncomeIconTheme("positive", false);
      } else if (previewInvestment.income < 0) {
        this.businessModel.setIncomeIconTheme("negative", false);
      } else {
        this.businessModel.setIncomeIconTheme(null, false);
      }
    }

    this.$element.find("[data-bm-preview-budget]").text(previewBudget);
    this.$element.find("[data-bm-preview-points]").text(this.roundOverview.currentRoundData.currentPoints + previewInvestment.points);
  }

  setActionBarVisible(flag) {
    if (flag) {
      this.$actionBarWrapper.removeClass("visibility-hidden");
    } else {
      this.$actionBarWrapper.addClass("visibility-hidden");
    }
  }

  setActionBarLayer(behindOverlay) {
    if (behindOverlay) {
      this.$actionBarWrapper.addClass("ab__back");
    } else {
      this.$actionBarWrapper.removeClass("ab__back");
    }
  }

  showEndGameView(endGameData) {
    if (!this.rendered) {
      this.showBusinessModelOnRender = false;
      this.executeOnRender.push(() => this.showEndGameView(endGameData));
      return;
    }

    this.endGameData = endGameData;

    this.$element.find(".business-model-wrapper").addClass("bm__mode-progress");

    this.$element.find("[data-bm-team-overview-back]").addClass("visibility-hidden");
    this.$element.find(".bm__mode-progress").addClass("visibility-hidden");
    this.showScoreScreen({
      mode: "endgame",
      title: LanguageManager.getValueForKey("serious_game.business_model.score_screen.title.end_score"),
      currentTeam: this.team,
      roundOverview: this.roundOverview,
      interactive: true,
      hideBusinessModel: false
    });
  }

  showTeamGameOverview(teamName) {
    if (utils.isNull(this.gameProgressController)) {
      this.renderGameProgressController();
    }

    if (utils.isNotNull(this.endGameData)) {
      let teamEndData;

      for (let i = 0; i < this.endGameData.teams.length; i++) {
        if (this.endGameData.teams[i].teamName === teamName) {
          teamEndData = this.endGameData.teams[i];
          break;
        }
      }

      if (utils.isNotNull(teamEndData)) {
        this.$element.find("[data-bm-team-overview-back]").removeClass("visibility-hidden");
        this.$element.find(".bm__mode-progress").removeClass("visibility-hidden");

        this.gameProgressController.roundIndex = 1;
        this.gameProgressController.roundProgressMap = teamEndData.roundProgress;
        this.gameProgressController.update();

        this.hideScoreScreen(false);

        if (utils.isFunction(this.onTeamOverviewChanged)) {
          this.onTeamOverviewChanged.call(this, teamEndData);
        }
      }
    } else {
      log.error("Trying to set up game overview without endGameData");
    }
  }

  // ==============================================
  //                    ACTIONS
  // ==============================================

  purchaseInvestment(investment) {
    if (investment.type === "extraproduct") {
      let extraProductIcons = [];

      for (let i = 0; i < this.caseWrapper.icons.length; i++) {
        if (this.caseWrapper.icons[i].type.includes("extension")) {
          extraProductIcons.push(this.caseWrapper.icons[i]);
        }
      }

      this.investmentExtraDialog.onExtraProductSelected = (extraProductId) => {
        this.executeOnInvestmentExtraClose = [];
        this.investmentExtraDialog.disableProductButtons(true);

        if (utils.isFunction(this.onInvestmentAdded)) {
          this.onInvestmentAdded.call(this, investment, extraProductId);
        }
      };
      this.executeOnInvestmentExtraClose = [() => {
        this.showInvestmentDialog(investment);
      }];

      this.hideInvestmentDialog(false);
      this.showInvestmentExtra(investment.type, {extraProductIcons});
    } else {
      this.investmentDialog.setPurchaseButtonLoading(true);

      if (utils.isFunction(this.onInvestmentAdded)) {
        this.onInvestmentAdded.call(this, investment);
      }

    }
  }

  closeRound() {
    log.info("Closing round [%d]", this.roundOverview.currentRoundData.roundIndex);

    this.closeRoundDialog.setCloseRoundButtonLoading(true);

    if (utils.isFunction(this.onTeamClosedRound)) {
      this.onTeamClosedRound.call(this);
    }
  }

  requestLoan() {
    log.info("Requesting loan in round [%d]", this.roundOverview.currentRoundData.roundIndex);

    this.loanDialog.setRequestLoanButtonLoading(true);

    if (utils.isFunction(this.onTeamRequestedLoan)) {
      this.onTeamRequestedLoan.call(this);
    }
  }

  // ==============================================
  //                    UTILS
  // ==============================================

  getRoundScore(roundIndex) {
    if (utils.isNull(this.roundOverview) || utils.isNull(this.roundOverview.commonDataSelf.roundScores)) return null;

    for (let i = 0; i < this.roundOverview.commonDataSelf.roundScores.length; i++) {
      let roundScore = this.roundOverview.commonDataSelf.roundScores[i];
      if (roundScore.round === roundIndex) {
        return roundScore;
      }
    }

    return null;
  }

  getInvestmentObjectsForTeam() {
    let investments = [];

    for (let roundIndex in this.team.roundData) {
      if (this.team.roundData.hasOwnProperty(roundIndex)) {
        let roundData = this.team.roundData[roundIndex];

        for (let i = 0; i < this.caseWrapper.investments.length; i++) {
          let investment = this.caseWrapper.investments[i];

          if (utils.isNotNull(roundData.investmentKey1) && investment.key === roundData.investmentKey1) {
            investments.push(investment);
          }

          if (utils.isNotNull(roundData.investmentKey2) && investment.key === roundData.investmentKey2) {
            investments.push(investment);
          }
        }
      }
    }

    return investments;
  }

  // ==============================================
  //                    EVENTS
  // ==============================================
  _setUpEventListeners() {
    this.$element.find(".bm-action-btn__score").off("click").on("click", this.onShowScoreScreen.bind(this));

    this.$element.find(".bm-action-btn__model").off("click").on("click", this.onShowBusinessModel.bind(this));

    this.$element.find(".bm-action-btn__investments").off("click").on("click", this.onShowInvestments.bind(this));

    this.$element.find(".bm-action-btn__faq").off("click").on("click", this.onShowHelp.bind(this));

    this.$element.find(".bm-action-btn__event").off("click").on("click", this.onShowEvent.bind(this));

    this.$element.find(".bm-action-btn__loan").off("click").on("click", this.onShowRequestLoan.bind(this));

    this.$element.find(".bm-action-btn__close-round").off("click").on("click", this.onCloseRound.bind(this));

    this.$element.find(".close-preview-btn").off("click").on("click", this.onClosePreview.bind(this));

    this.$element.find(".show-tutorial-btn").off("click").on("click", this.onShowTutorial.bind(this));
    this.$element.find(".close-faq-btn").off("click").on("click", this.onCloseFaq.bind(this));

    this.$element.find(".back-to-score-btn").off("click").on("click", this.onCloseTeamOverview.bind(this));
  }

  pulsateEventButton() {
    log.info("Pulsating event button (possible delay)");

    this.$element.find(".bm-action-btn__event").removeClass("bounce animated").addClass("bounce animated").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
      $(this).removeClass("bounce animated");
    });
  }

  pulsateLoanButton() {
    log.info("Pulsating event button (possible delay)");

    this.$element.find(".bm-action-btn__loan").removeClass("bounce animated").addClass("bounce animated").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
      $(this).removeClass("bounce animated");
    });
  }

  onShowScoreScreen(e) {
    log.info("Click on show score screen");
    this.showScoreScreen({
      currentTeam: this.team,
      title: utils.format(LanguageManager.getValueForKey("serious_game.business_model.score_screen.title.round_result"), this.roundOverview.currentRoundData.roundIndex - 1),
      roundOverview: this.roundOverview,
      roundIndex: this.roundOverview.currentRoundData.roundIndex - 1,
      asOverlay: true,
      mode: "previous-round"
    });
  }

  onShowBusinessModel(e) {
    log.info("Click on show business model");
    this.showBusinessModel(true);
  }

  onShowInvestments(e) {
    log.info("Clicked on show investments");
    this.showInvestments();
  }

  onInvestmentClicked(investment) {
    log.info("Clicked on investment - %o", investment);
    this.showInvestmentDialog(investment);
  }

  onShowHelp(e) {
    log.info("Click on show faq");
    this.showFaq();
  }

  onShowEvent(e) {
    log.info("Click on show event");
    this.showEventDialog();
  }

  onShowRequestLoan(e) {
    log.info("Click on request loan");
    this.showLoanDialog("request-loan");
  }

  onCloseRound(e) {
    log.info("Click on close round");
    this.showCloseRoundDialog();
  }

  onClosePreview(e) {
    log.info("Click on close preview");
    this.showInvestmentDialog();
    this.hidePreview();
  }

  onShowTutorial(e) {
    log.info("Click on show tutorial");
    this.showTutorialDialog(false);
  }

  onCloseFaq(e) {
    log.info("Click on close faq");
    this.hideFaq();
    this.showBusinessModel(true, true);
  }

  onInvestmentDialogCancel(investmentDialog) {
    log.info("Investment [%s] cancelled", investmentDialog.investment.type);
    this.showInvestments();

    if (utils.isArray(this.executeOnInvestmentClose)) {
      // Make copy and clear original
      let executeCopy = this.executeOnInvestmentClose.splice(0);

      for (let i = 0; i < executeCopy.length; i++) {
        executeCopy[i].call(this);
      }
    }
  }

  onInvestmentViewExamples(investmentDialog) {
    log.info("Investment [%s] - requesting examples", investmentDialog.investment.type);
    this.showInvestmentExamplesDialog(investmentDialog.investment);
  }

  onInvestmentShowPreview(investmentDialog) {
    log.info("Investment [%s] - requesting preview", investmentDialog.investment.type);
    this.showPreview(investmentDialog.investment);
  }

  onInvestmentPurchased(investmentDialog) {
    log.info("Investment [%s] - purchasing", investmentDialog.investment.type);
    this.purchaseInvestment(investmentDialog.investment);
  }

  onCloseRoundDialogCancel() {
    log.info("Cancelled close round dialog");
    this.hideCloseRoundDialog();
  }

  onViewInvestments() {
    log.info("Viewing investments");
    this.showInvestments();
  }

  onTutorialCancel() {
    log.info("Cancelled tutorial dialog");
    this.hideTutorialDialog();
    this.showBusinessModel(true, true);
  }

  onEventDialogCancel() {
    log.info("Cancelled event dialog");
    this.showBusinessModel(true, true);

    if (utils.isArray(this.executeOnEventClose)) {
      // Make copy and clear original
      let executeCopy = this.executeOnEventClose.splice(0);

      for (let i = 0; i < executeCopy.length; i++) {
        executeCopy[i].call(this);
      }
    }
  }

  onInvestmentExtraDialogCancel() {
    log.info("Cancelled investment extra dialog");
    this.hideInvestmentExtraDialog(true);

    if (utils.isArray(this.executeOnInvestmentExtraClose)) {
      // Make copy and clear original
      let executeCopy = this.executeOnInvestmentExtraClose.splice(0);

      for (let i = 0; i < executeCopy.length; i++) {
        executeCopy[i].call(this);
      }
    }
  }

  onFaqDialogCancel() {
    log.info("Cancelled faq dialog");
    this.hideFaqDialog(true);
    this.showFaq();
  }

  onViewInvestment(faqDialog, investment) {
    log.info("Viewing investment linked to faq item - %o", investment);
    this.hideFaqDialog(false);

    this.executeOnInvestmentClose.push(() => {
      this.showFaqDialog();
    });

    this.showInvestmentDialog(investment);
  }

  onGameBonusDialogCancel() {
    log.info("Cancelled game bonus dialog");
    this.hideGameBonusDialog(true);
    this.showBusinessModel(true, true);
  }

  onExampleCaseDialogCancel() {
    log.info("Cancelled example cases dialog");
    this.hideInvestmentExamplesDialog(true);

    if (utils.isArray(this.executeOnExampleCasesClose)) {
      // Make copy and clear original
      let executeCopy = this.executeOnExampleCasesClose.splice(0);

      for (let i = 0; i < executeCopy.length; i++) {
        executeCopy[i].call(this);
      }
    }
  }

  onLoanDialogCancel() {
    log.info("Cancelled loan dialog");
    this.hideLoanDialog(true);

    if (utils.isArray(this.executeOnLoanDialogClose)) {
      // Make copy and clear original
      let executeCopy = this.executeOnLoanDialogClose.splice(0);

      for (let i = 0; i < executeCopy.length; i++) {
        executeCopy[i].call(this);
      }
    }
  }

  onTeamScoreClick(e, teamName) {
    log.info("Clicked on game overview in score screen for team [%s] - %o", teamName, e);
    this.showTeamGameOverview(teamName);
  }

  onCloseTeamOverview(e) {
    this.showEndGameView(this.endGameData);

    if (utils.isFunction(this.onTeamOverviewClosed)) {
      this.onTeamOverviewClosed.call(this);
    }
  }
}

module.exports = BusinessModelView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/business-model.js